import { Navigate, useLocation } from "react-router-dom";
import { LogoSplash } from "@/components/site/LogoSplash";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, host = false }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <LogoSplash testId="auth-loading" />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (host && user.role !== "host") return <Navigate to="/dashboard" replace />;
  return children;
}

export function Spinner() {
  return <LogoSplash />;
}
